/* eslint-disable */
// @ts-nocheck

import { createContext, useEffect, useState } from 'react'
import {
  Control,
  FieldValues,
  SubmitHandler,
  useFieldArray,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  useForm,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form'

import useServerArea from '../../../../../api/useServerArea'
import Fetching from '../../../../../components/misc/Fetching'
import StepsComponent from '../../../../../components/misc/StepsComponent'
import { DispatchItemInterface } from '../../../../../interfaces/ServerInterfaces'
import { cleanObj, cleanObject } from '../../../../../utils/helpers'
import AreasSelectorStep from './AreasSelectorStep'
import NotesFinishStep from './NotesFinishStep'
import ProductMovementStep from './ProductMovementStep'

interface WizardInterface {
  submitAction: Function
  loading: boolean
  transformingToDispatch?: boolean
  despacho?: DispatchItemInterface
}

interface DispatchContextInterface {
  control: Control
  watch: UseFormWatch<Record<string, any>>
  trigger: UseFormTrigger<Record<string, any>>
  setValue: UseFormSetValue<Record<string, any>>
  setCurrentStep: Function
  transformingToDispatch?: boolean
  despacho?: DispatchItemInterface
  fields: Record<'id', string>[]
  append: UseFieldArrayAppend<FieldValues, 'products'>
  update: UseFieldArrayUpdate<FieldValues, 'products'>
  remove: UseFieldArrayRemove
}

export const DispatchContext = createContext<Partial<DispatchContextInterface>>(
  {}
)

const DispatchWizard = ({
  submitAction,
  loading,
  transformingToDispatch,
  despacho,
}: WizardInterface) => {
  const { getAreasToDispatch, allAreas, sharesAreas, isLoading } =
    useServerArea()
  const {
    stockProducts,
    getProductsByArea,
    isLoading: loadingProducts,
  } = useServerArea()
  const { handleSubmit, control, watch, setValue, trigger, unregister } =
    useForm()

  const { fields, append, update, remove } = useFieldArray({
    control,
    name: 'products',
  })

  useEffect(() => {
    if (allAreas.length === 0 && sharesAreas.length === 0) getAreasToDispatch()
     
  }, [])

  useEffect(() => {
    const stockId = watch('stockAreaFromId')
    if (stockId)
      getProductsByArea(stockId, {
        all_data: true,
      })
    unregister('products')
     
  }, [watch('stockAreaFromId')])

  //Manage Steps Component ------------------------------------------------------
  const [currentStep, setCurrentStep] = useState(0)
  const stepsData: string[] = [
    'Origen / Destino',
    'Seleccionar productos',
    'Observaciones',
  ]
  //------------------------------------------------------------------------

  //Submit action -------------------------------------------------------------
  const onSubmit: SubmitHandler<Record<string, any>> = (data) => {
    //Clean products object funtion--------------------------------------

    const products = data?.products?.map((item: Record<string, string>) =>
      cleanObject(item, [
        'id',
        'productName',
        'measure',
        'variationName',
        'available',
      ])
    )
    data.products = products
    data = cleanObject(data, ['originAreaName', 'destinationAreaName'])
    data.mode = 'MOVEMENT'
    //--------------------------------------------------------------------
    submitAction(cleanObj(data))
  }
  //---------------------------------------------------------------------------

  // const stockProductsTransformingDispatch = stockProducts.map(prod => {

  //   const quantity = despacho?.products.find(item => item.productId === prod.product.id!)?.quantity ?? 0

  //   const available = prod.product.totalQuantity

  //   const availableRest = available - quantity;

  //   return {
  //     ...prod,
  //     quantity: availableRest,
  //   }

  // })

  if (isLoading || loading) return <Fetching className="h-96" />
  return (
    <>
      <StepsComponent current={currentStep} titles={stepsData} />
      <DispatchContext.Provider
        value={{
          control,
          watch,
          setValue,
          setCurrentStep,
          trigger,
          transformingToDispatch,
          despacho,
          fields,
          append,
          update,
          remove,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          {currentStep === 0 && (
            <AreasSelectorStep
              allMyAreas={allAreas}
              sharesAreas={sharesAreas}
            />
          )}
          {currentStep === 1 && (
            <ProductMovementStep
              loading={loadingProducts}
              stockProducts={stockProducts}
            />
          )}
          {currentStep === 2 && <NotesFinishStep loading={loading} />}
        </form>
      </DispatchContext.Provider>
    </>
  )
}

export default DispatchWizard
